import { Redirect } from "react-router-dom";
import { React } from "react";
const logout = require("../js_utils/logout");

export default function Logout() {
  logout();
  return <Redirect to="/login" />;
}
